import styled from 'styled-components';

export const Container = styled.div`
  height: 100vh;
  max-height: 100vh;
  background-color: white;
  border-right: 1px solid;
  border-color: #c3c3c3;
`;

export const Navbar = styled.div`
  height: 51px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid;
  border-color: #c3c3c3;
  padding: 0 8px;
`;

export const HStack = styled.div`
  display: flex;
  align-items: center;
  padding: 8px;
  gap: 8px;
`;

export const SearchBox = styled.div`
  padding: 8px;
  border-bottom: 1px solid;
  border-color: #c3c3c3;
`;

export const ChatsScrollView = styled.div`
  overflow-y: auto;
  height: ${(props) => props.height};
`;
